import { Content } from "@/src/components/wrappers/Content";
import { useLocation } from "react-router-dom";
import { CustomersTable } from "./tables/CustomersTable";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";
import { ActionsContext, useEmit } from "@/src/lib/actions";
import { useEffect, useState } from "react";
import { FiltersButton } from "./FiltersButton";
import OrderBySelect from "./OrderBySelect";
import { PayerType } from "./model";

export function Customers() {
  const [activeTab, setActiveTab] = useState<"customers" | "operators">("customers");
  const [shouldRefetch, setShouldRefetch] = useState(false);

  useEffect(() => {
    if (shouldRefetch) {
      setShouldRefetch(false);
    }
  }, [shouldRefetch]);

  return (
    <ActionsContext>
      <Content title="Customers">
        <div className="mb-2 flex justify-start items-center gap-2">
          <FiltersButton />
          <PageSizeSelect />
          <OrderBySelect payerType={activeTab === "customers" ? PayerType.CUSTOMER : PayerType.OPERATOR} />
        </div>
        <CustomersTable shouldRefetch={shouldRefetch} setShouldRefetch={setShouldRefetch} />
      </Content>
    </ActionsContext>
  );
}

function PageSizeSelect() {
  const [value, setValue] = useState("10");
  const emit = useEmit<number>("payments-customers:page-size");

  const onValueChange = (value: string) => {
    setValue(value);
    emit(parseInt(value));
  };

  return (
    <div className="w-60 ml-auto">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Page size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="5">Show: 5 at once</SelectItem>
          <SelectItem value="10">Show: 10 at once</SelectItem>
          <SelectItem value="20">Show: 20 at once</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
